import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200
    },
    root: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start'
    },
    passwordInfo: {
        margin: 5,
        color: '#3F51B5',
        fontWeight: 'bold'

    },
    errorIcon: {
        color: 'red'
    },
    successIcon: {
        color: 'green'
    }
}));

export {useStyles};